const TicketItem = (props) => {
    const data = {
        number: props.number ? props.number : null,
        title: props.title ? props.title : null,
        status: props.status ? props.status : null,
        date: props.date ? props.date : null,
        clickEV: props.clickEV ? props.clickEV : null,
    }
    return (
        <div className="border rounded p-2 nfs-10 fw300 mb-2" >
            <div className="row">
                <div className="col-6">
                    <p>
                        <span className="ml-1" style={{ color: "#5C5C5C" }}>شماره تیکت:</span>
                        {data.number}
                    </p>
                    <p>
                        <span className="ml-1" style={{ color: "#5C5C5C" }}> عنوان:</span>
                        {data.title}
                    </p>
                    <p className="my-1">
                        <span className="ml-1" style={{ color: "#5C5C5C" }}>تاریخ ایجاد :</span>
                        {data.date}
                    </p>
                    <p>
                        {data.text}
                    </p>
                </div>
                <div className="col-6 text-left">
                    <p className="text-left">
                        <span className="ml-1 " style={{ color: "#5C5C5C" }}>وضعیت: </span>
                        {data.status}
                    </p>
                    <button className="btn btn-primary mt-3" onClick={data.clickEV}>
                        نمایش
                    </button>
                </div>
            </div>

        </div>

    );
}

export default TicketItem;